// extracted by mini-css-extract-plugin
export default {"meetingDetails":"meetingDetails-module__meetingDetails___TP6ow"};